import React from 'react'
import Accordions from "../../../components/Accordions";

const Sem4Ecce1 = () => {
  const data = [
    // {
    //   subjectName: "2023 Batch",
    //   units: [ ],
    //   links: [
    //     {
    //       url: "https://drive.google.com/file/d/1uCQ9yhJjrlw05s4Xf4gmBPe21q3-7_hq/view?usp=sharing",
    //       title: "Syllabus",
    //     },
    //   ],
    // },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://www.sonatech.ac.in/academics/syllabus/B.E-B.Tech/2024-Batch/EFE-1-5-Sem-Curriculum-Syllabus-Honours.pdf",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">EFE Sem - 4</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem4Ecce1